import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenRefreshService } from './token-refresh.service';

@Injectable()
export class AuthUnauthorizedInterceptor implements HttpInterceptor {
  private static readonly rolesEndpointPath = '/api/v1/user/roles';
  private tokenRefreshService = inject(TokenRefreshService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (
          error instanceof HttpErrorResponse
          && error.status === 401
          && this.isRolesEndpoint(req.url)
        ) {
          // Attempt silent token refresh on 401 for roles endpoint
          void this.handleUnauthorizedRolesRequest();
        }

        return throwError(() => error);
      })
    );
  }

  private async handleUnauthorizedRolesRequest(): Promise<void> {
    const tokenRefreshed = await this.tokenRefreshService.tryRefreshTokenSilently();
    if (!tokenRefreshed) {
      // Token refresh failed - force logout and re-login
      this.tokenRefreshService.handleTokenRefreshFailure();
    }
    // If token refreshed successfully, the next API call will use the new token
  }

  private isRolesEndpoint(url: string): boolean {
    const normalizedUrl = url.toLowerCase().split('?')[0];
    return normalizedUrl.endsWith(AuthUnauthorizedInterceptor.rolesEndpointPath);
  }
}